/* Stylesheet  */

.item_options {
  .option {
    width: 52px;
  }
  .edit {
    background: var(--ion-color-primary);
  }
  .delete {
    background: var(--ion-color-error);
  }

  .icon {
    height: 18px;
    width: 18px;
  }
}

.list_item {
  --padding-start: 42px;
  color: var(--ion-color-text-primary);
  --color-hover: var(--ion-color-text-primary);
  --background-activated: transparent;
  --background-hover-opacity: 0.075;

  .index {
    margin: 0px 21px 0px 0px;
    color: var(--ion-color-text-tertiary);
    font-size: 0.75rem;
  }
}
